/**
 * Shared time utility functions used by TimePicker, TimeRangePicker, and other
 * time-related components. Extracted to eliminate duplication.
 */

/** Convert "HH:mm" to total minutes for comparison */
export function timeToMinutes(time: string): number {
  const [h, m] = time.split(':').map(Number);
  return h * 60 + m;
}

/** Format a 24h "HH:mm" value for display */
export function formatTimeDisplay(value: string, is24Hour: boolean): string {
  if (!value) return '';
  const [h, m] = value.split(':').map(Number);
  if (isNaN(h) || isNaN(m)) return '';

  if (is24Hour) {
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
  }

  const period = h >= 12 ? 'PM' : 'AM';
  const h12 = h % 12 || 12;
  return `${h12}:${String(m).padStart(2, '0')} ${period}`;
}

/** Generate the list of hour options for the picker UI */
export function getHourOptions(is24Hour: boolean): number[] {
  if (is24Hour) {
    return Array.from({ length: 24 }, (_, i) => i);
  }
  return Array.from({ length: 12 }, (_, i) => i + 1);
}

/** Generate minute options based on step interval */
export function getMinuteOptions(step: number): number[] {
  const mins: number[] = [];
  for (let i = 0; i < 60; i += step) {
    mins.push(i);
  }
  return mins;
}

/** Convert 24h hour to 12h display hour */
export function to12Hour(h24: number): number {
  return h24 % 12 || 12;
}

/** Convert 12h hour + period to 24h hour */
export function to24Hour(h12: number, period: 'AM' | 'PM'): number {
  if (period === 'AM') {
    return h12 === 12 ? 0 : h12;
  }
  return h12 === 12 ? 12 : h12 + 12;
}
